var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5C13 20.813 13.461 21.358 14.53 21.893C15.914 22.585 17.877 23 20 23C22.123 23 24.086 22.585 25.47 21.893C26.539 21.358 27 20.813 27 20.5V18.329C25.35 19.349 22.827 20 20 20C17.173 20 14.65 19.348 13 18.329V20.5ZM27 23.329C25.35 24.349 22.827 25 20 25C17.173 25 14.65 24.348 13 23.329V25.5C13 25.813 13.461 26.358 14.53 26.893C15.914 27.585 17.877 28 20 28C22.123 28 24.086 27.585 25.47 26.893C26.539 26.358 27 25.813 27 25.5V23.329ZM11 25.5V15.5C11 13.015 15.03 11 20 11C24.97 11 29 13.015 29 15.5V25.5C29 27.985 24.97 30 20 30C15.03 30 11 27.985 11 25.5ZM20 18C22.123 18 24.086 17.585 25.47 16.893C26.539 16.358 27 15.813 27 15.5C27 15.187 26.539 14.642 25.47 14.107C24.086 13.415 22.123 13 20 13C17.877 13 15.914 13.415 14.53 14.107C13.461 14.642 13 15.187 13 15.5C13 15.813 13.461 16.358 14.53 16.893C15.914 17.585 17.877 18 20 18Z",
    fill: "#4778F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompData);
export default __webpack_public_path__ + "static/media/compData.0616f83fca801592915efc594be2025c.svg";
export { ForwardRef as ReactComponent };